/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Perm_InboxInputs */

const en_team_perm_inbox = /** @type {(inputs: Team_Perm_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox`)
};

const es_team_perm_inbox = /** @type {(inputs: Team_Perm_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandeja de Entrada`)
};

const fr_team_perm_inbox = /** @type {(inputs: Team_Perm_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boîte de réception`)
};

const de_team_perm_inbox = /** @type {(inputs: Team_Perm_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posteingang`)
};

const id_team_perm_inbox = /** @type {(inputs: Team_Perm_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotak Masuk`)
};

/** @type {(inputs: Team_Perm_InboxInputs) => LocalizedString} */
const ja_team_perm_inbox = en_team_perm_inbox;

/** @type {(inputs: Team_Perm_InboxInputs) => LocalizedString} */
const zh_team_perm_inbox = en_team_perm_inbox;

/** @type {(inputs: Team_Perm_InboxInputs) => LocalizedString} */
const ar_team_perm_inbox = en_team_perm_inbox;

/** @type {(inputs: Team_Perm_InboxInputs) => LocalizedString} */
const it_team_perm_inbox = en_team_perm_inbox;

/** @type {(inputs: Team_Perm_InboxInputs) => LocalizedString} */
const ru_team_perm_inbox = en_team_perm_inbox;

/** @type {(inputs: Team_Perm_InboxInputs) => LocalizedString} */
const pt_team_perm_inbox = en_team_perm_inbox;

/** @type {(inputs: Team_Perm_InboxInputs) => LocalizedString} */
const ko_team_perm_inbox = en_team_perm_inbox;

/**
* | output |
* | --- |
* | "Inbox" |
*
* @param {Team_Perm_InboxInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_perm_inbox = /** @type {((inputs?: Team_Perm_InboxInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Perm_InboxInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_perm_inbox(inputs)
	if (locale === "es") return es_team_perm_inbox(inputs)
	if (locale === "fr") return fr_team_perm_inbox(inputs)
	if (locale === "de") return de_team_perm_inbox(inputs)
	if (locale === "ja") return ja_team_perm_inbox(inputs)
	if (locale === "zh") return zh_team_perm_inbox(inputs)
	if (locale === "ar") return ar_team_perm_inbox(inputs)
	if (locale === "id") return id_team_perm_inbox(inputs)
	if (locale === "it") return it_team_perm_inbox(inputs)
	if (locale === "ru") return ru_team_perm_inbox(inputs)
	if (locale === "pt") return pt_team_perm_inbox(inputs)
	return ko_team_perm_inbox(inputs)
});